import React, { forwardRef } from 'react';

import { BaseMenuOption } from 'src/editor/toolbars/menus/BaseMenuOption';
import type { CommonMenuItemProps } from 'src/editor/toolbars/menus/types';
import { ClientTransforms } from 'src/editor/transforms';
import { useCurrentUserId } from 'src/gql';
import { useAuthorizedTransforms } from 'src/hooks';
import { useEditor } from 'src/layout-engine';
import { useEditingMode } from 'src/store/document/selectors';

interface DeleteTableRowsMenuItemProps extends CommonMenuItemProps {
  numberOfRows: number;
}

export const DeleteTableRowsMenuItem = forwardRef(function DeleteTableRowsMenuItem(
  props: DeleteTableRowsMenuItemProps,
  ref: React.Ref<HTMLLIElement>
): JSX.Element {
  const { closeRootMenu, numberOfRows, ...rest } = props;
  const currentUserId = useCurrentUserId();
  const { editingMode } = useEditingMode();
  const editor = useEditor();
  const { AuthorizedTransforms } = useAuthorizedTransforms();

  const isMultipleRows = numberOfRows > 1;
  const label = isMultipleRows ? `Delete ${numberOfRows} rows` : `Delete row`;

  function deleteTableRow(): void {
    if (!editingMode || !currentUserId) return closeRootMenu();

    AuthorizedTransforms.deleteTableRows(editor, { authorId: currentUserId, editingMode });
    ClientTransforms.focus(editor);
    closeRootMenu();
  }

  return <BaseMenuOption ref={ref} label={label} onClick={deleteTableRow} {...rest} />;
});
